import Terms from '@page/Legal/Terms'
export default Terms
